/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Loading/view.blocks to change it.
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'



/** @type {import('Simple/types.js').View} */
export default function Loading({
  children,
  viewPath = "/DesignSystem/DataVaxiomPatientInsuranceAssignForm/Content/PolicyHolder/Options/AddRelationship/Content/Phone/Existing/Loading"
  
}) {
  return (<React.Fragment
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text="Loading..."
/>
{children}
</React.Fragment>)
}